import { render, staticRenderFns } from "./NewsAndUpdates.vue?vue&type=template&id=c69ccfe8&scoped=true&"
import script from "./NewsAndUpdates.vue?vue&type=script&lang=js&"
export * from "./NewsAndUpdates.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndUpdates.vue?vue&type=style&index=0&id=c69ccfe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69ccfe8",
  null
  
)

export default component.exports